module.exports = __webpack_public_path__ + "img/jimny-glx-gris.a3ce9721.png";